module.exports = __webpack_public_path__ + "img/517dce5.png";